import { CardMedia } from "@mui/material";
import banner from "../../Assets/Images/banner.jpg";

export const BannerPage = () => <CardMedia component="img" image={banner} />